export default "__VITE_ASSET__NEdLL4Rs__"